import { useTranslation } from 'react-i18next'

import styles from '../NonprofitDetail.module.scss'

import { FraudCheckDomainAnalysis } from '@percent/admin-dashboard/common/components/fraudChecks/fraudCheckDomainAnalysis/FraudCheckDomainAnalysis'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { Alert, CardDashboard, Flex } from '@percent/lemonade'
import { useQuery } from '@percent/utility'
import { AutoDomainFraudChecksAlert } from '@percent/admin-dashboard/common/components/fraudChecks/autoDomainFraudChecksAlert/AutoDomainFraudChecksAlert'
import { getGroupedFraudChecks } from '@percent/admin-dashboard/common/components/fraudChecks/utils/getGroupedFraudChecks'

export function VRFraudChecks({ id }: { id: string }) {
  const { adminService } = useServices()
  const { t } = useTranslation()

  const { data: fraudCheckResults, isLoading: isLoadingFraudCheckResults } = useQuery(
    ['/validation-requests', id, '/fraud-check-results'],
    adminService.getVRFraudCheckResults,
    { id }
  )

  const groupedFraudChecks = getGroupedFraudChecks(fraudCheckResults)

  const failedAgentChecks = groupedFraudChecks?.agent.failedChecks
  const firstDomainFailedChecks = groupedFraudChecks?.domains[0]?.failedChecks

  const shouldShowSingleDomainAnalysis =
    groupedFraudChecks?.domains.length === 1 && !!firstDomainFailedChecks && firstDomainFailedChecks.total > 0
  const shouldShowMultipleDomainAnalysis =
    !!groupedFraudChecks?.domains.length && groupedFraudChecks?.domains.length > 1
  const shouldShowAgentAnalysis = !!failedAgentChecks?.length && failedAgentChecks.length > 0

  if (
    isLoadingFraudCheckResults ||
    !fraudCheckResults?.checkResults.length ||
    !groupedFraudChecks ||
    !failedAgentChecks
  ) {
    return null
  }

  return (
    <>
      {(shouldShowAgentAnalysis || shouldShowSingleDomainAnalysis) && (
        <CardDashboard title={t('typography.fraudFlags')} className={styles.listContainer}>
          {shouldShowAgentAnalysis && (
            <Flex mb={8} w="100%" direction="column">
              <Alert variant="warning" title={t('fraudReason.scope.agent')}>
                <ul>
                  {failedAgentChecks.map(check => (
                    <li key={check.checkName}>{t(`autoFraudChecks.agent.${check.checkName}`)}</li>
                  ))}
                </ul>
              </Alert>
            </Flex>
          )}
          {shouldShowSingleDomainAnalysis && firstDomainFailedChecks && (
            <AutoDomainFraudChecksAlert failedAutoChecks={firstDomainFailedChecks} />
          )}
        </CardDashboard>
      )}
      {shouldShowMultipleDomainAnalysis && (
        <Flex direction="column" gap={24} align="stretch" w="100%" mt={24}>
          <FraudCheckDomainAnalysis groupedFraudChecks={groupedFraudChecks} isAutoFraudCheckEnabled />
        </Flex>
      )}
    </>
  )
}
